import React from 'react';

function Fiji(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124137)">
        <mask
          id="mask0_800_124137"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124137)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#67BFE5"
          />
          <mask
            id="mask1_800_124137"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124137)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.5 10H33.3621V18.3333C33.3621 18.3333 32.4512 22 27.931 22C23.4109 22 22.5 18.3333 22.5 18.3333V10Z"
              fill="#F7FCFF"
            />
            <mask
              id="mask2_800_124137"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="22"
              y="10"
              width="12"
              height="12"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.5 10H33.3621V18.3333C33.3621 18.3333 32.4512 22 27.931 22C23.4109 22 22.5 18.3333 22.5 18.3333V10Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask2_800_124137)">
              <rect x="22.5" y="10" width="10.8621" height="3" fill="#C3352C" />
              <rect
                x="27.1553"
                y="12.6666"
                width="1.55172"
                height="9.33333"
                fill="#C3352C"
              />
              <rect
                x="22.5"
                y="16.3333"
                width="10.8621"
                height="1.33333"
                fill="#C3352C"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.3581 20.7371C26.0112 21.5578 26.5434 21.8781 26.9196 21.3945C27.184 21.0546 27.2113 20.7147 26.8346 20.6482C26.6161 20.4013 26.4619 20.2088 26.3738 20.0745L26.3865 20.064C26.4921 19.9726 26.4961 19.8509 26.4752 19.8055C26.4673 19.7434 26.5197 19.659 26.8591 19.4283C27.1666 19.2194 27.3029 19.0227 27.1014 18.806C26.9955 18.6921 26.9003 18.6693 26.6001 18.6281L26.5078 18.6154C26.419 18.6027 26.3544 18.5901 26.3137 18.5792L26.1049 18.2236C25.6689 18.2118 25.3281 18.2801 24.9554 18.42C24.7949 18.4802 24.6867 18.5212 24.6144 18.5485C24.5042 18.5902 24.4779 18.6002 24.4772 18.5987C24.477 18.5982 24.4793 18.5965 24.4823 18.5944C24.4909 18.5883 24.5053 18.5782 24.4845 18.5782C24.4058 18.5782 24.3207 18.5703 24.0845 18.5436L24.0382 18.5384C23.3592 18.4626 23.1891 18.465 23.0791 18.746C22.9117 19.1735 23.9028 19.9571 24.429 20.0512C24.6925 20.0983 25.008 20.3226 25.3581 20.7371ZM26.0964 20.1486C26.1602 20.1486 26.2095 20.1463 26.2528 20.1359L26.266 20.1102C26.2306 20.1316 26.1775 20.1486 26.0964 20.1486ZM23.6183 18.9682C23.6044 18.9537 23.6007 18.935 23.6103 18.9103C23.6083 18.9154 23.6147 18.9264 23.6279 18.942L23.6183 18.9682ZM23.6856 19.0002C23.6607 18.9771 23.641 18.9573 23.628 18.942L23.6184 18.9682C23.632 18.9824 23.6554 18.9925 23.6856 19.0002ZM24.54 19.561C24.3514 19.5273 23.8718 19.1726 23.6856 19.0002C23.7344 19.0126 23.801 19.0187 23.8726 19.0252C23.9038 19.028 23.936 19.0309 23.9682 19.0345L24.0137 19.0396C24.2791 19.0696 24.3717 19.0782 24.4845 19.0782C24.5496 19.0782 24.5361 19.0981 24.528 19.1102C24.5256 19.1138 24.5236 19.1168 24.5244 19.1182C24.5276 19.1243 24.5778 19.1053 24.8359 19.008C24.923 18.9751 25.0337 18.9333 25.1743 18.8806C25.3735 18.8058 25.5553 18.7574 25.7549 18.7356C25.777 18.8194 25.8317 18.8951 25.921 18.9567C26.0408 19.0393 26.1761 19.074 26.4088 19.1076C26.1196 19.3192 25.9744 19.4962 25.9285 19.6688C25.6684 19.742 25.6921 20.0026 25.8482 20.2631C25.957 20.4447 26.1626 20.7021 26.4686 21.0425L26.6884 21.1365C26.6235 21.1365 26.5873 21.11 26.5598 21.09C26.5251 21.0647 26.5042 21.0494 26.457 21.1101C26.4538 21.1142 26.2492 20.991 25.8126 20.4426C25.3829 19.9336 24.966 19.6372 24.54 19.561ZM25.9118 19.8606C25.9158 19.8577 25.9153 19.8538 25.9149 19.8499L25.9149 19.8498L25.9118 19.8606ZM26.0917 19.6487L26.0748 19.6489L26.0827 19.6494C26.0858 19.649 26.0887 19.6488 26.0917 19.6487ZM26.0964 19.6486C26.0948 19.6486 26.0932 19.6486 26.0917 19.6487L26.0964 19.6486Z"
                fill="#979797"
              />
              <path
                d="M24.3619 16.1102C24.3619 16.1102 23.8252 15.4502 23.8252 15.2149"
                stroke="#964C36"
              />
              <path
                d="M24.0285 15.5429C24.0285 15.5429 23.3423 15.2823 23.3423 15.5429"
                stroke="#2A8E51"
              />
              <path
                d="M24.0174 15.2689C24.0174 15.2689 23.5347 14.7231 23.1718 14.7231C22.8089 14.7231 22.8176 14.996 22.8176 14.996"
                stroke="#2A8E51"
              />
              <path
                d="M23.742 14.722C23.742 14.722 23.5266 13.8292 23.1816 13.8292C22.8367 13.8292 22.8367 14.2756 22.8367 14.2756"
                stroke="#2A8E51"
              />
              <path
                d="M23.8291 14.7202C23.8291 14.7202 23.733 13.9551 24.1772 13.9551"
                stroke="#2A8E51"
              />
              <path
                d="M25.0436 15.9811C25.0436 15.9811 24.7933 15.1977 24.8838 14.9766"
                stroke="#964C36"
              />
              <path
                d="M24.9487 15.3467C24.9487 15.3467 24.4041 14.8932 24.3039 15.138"
                stroke="#2A8E51"
              />
              <path
                d="M25.0438 15.0858C25.0438 15.0858 24.8003 14.4261 24.4593 14.3158C24.1183 14.2055 24.0214 14.4646 24.0214 14.4646"
                stroke="#2A8E51"
              />
              <path
                d="M24.9952 14.4882C24.9952 14.4882 25.1363 13.5838 24.8122 13.4789C24.488 13.374 24.3163 13.7935 24.3163 13.7935"
                stroke="#2A8E51"
              />
              <path
                d="M25.0779 14.513C25.0779 14.513 25.282 13.7649 25.6993 13.8999"
                stroke="#2A8E51"
              />
              <path
                d="M25.596 16.2601C25.596 16.2601 25.9519 15.5097 25.8923 15.2805"
                stroke="#964C36"
                strokeWidth="0.7"
              />
              <path
                d="M25.7772 15.6407C25.7772 15.6407 26.3799 15.2496 26.4458 15.5034"
                stroke="#2A8E51"
                strokeWidth="0.7"
              />
              <path
                d="M25.7189 15.3714C25.7189 15.3714 26.0511 14.7431 26.4047 14.6705C26.7582 14.598 26.8189 14.8656 26.8189 14.8656"
                stroke="#2A8E51"
                strokeWidth="0.7"
              />
              <path
                d="M25.849 14.7835C25.849 14.7835 25.8329 13.8706 26.169 13.8016C26.5051 13.7326 26.6181 14.1675 26.6181 14.1675"
                stroke="#2A8E51"
                strokeWidth="0.7"
              />
              <path
                d="M25.7634 14.7992C25.7634 14.7992 25.6634 14.0345 25.2306 14.1233"
                stroke="#2A8E51"
                strokeWidth="0.7"
              />
              <path
                d="M30.0352 15.8019C30.0352 15.8019 30.3074 14.6884 31.0821 14.6884C31.8568 14.6884 32.2035 15.8648 32.2035 15.8648"
                stroke="#2A8E51"
                strokeWidth="0.7"
              />
              <path
                d="M29.3955 15.0417C29.3955 15.0417 29.8127 14.384 31.1895 14.4378C32.5663 14.4916 32.8173 15.0417 32.8173 15.0417"
                stroke="#2A8E51"
                strokeWidth="0.7"
              />
              <path
                d="M29.1172 14.2054C29.1172 14.2054 29.8735 13.3726 30.9335 14.0785L31.2925 14.2054C31.2925 14.2054 31.6526 13.2617 33.3922 14.2054"
                stroke="#2A8E51"
                strokeWidth="0.7"
              />
              <path
                d="M31.2058 16.037C31.2058 16.037 31.2611 14.9977 31.4465 14.7123"
                stroke="#964C36"
              />
              <path
                d="M32.7361 18.3139C32.7361 18.3139 32.0407 18.0232 31.8326 18.3139C31.6245 18.6046 29.1182 21.2757 29.1182 21.2757"
                stroke="#964C36"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.3347 18.5952L31.8881 19.5604C31.8881 19.5604 32.6031 19.1071 32.2456 18.8511C31.8881 18.5952 30.9141 18.1439 30.9141 18.1439L30.3347 18.5952Z"
                fill="#FFF203"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.2811 18.6445C30.2811 18.6445 29.9213 18.9794 29.9213 19.2354C29.9213 19.4913 29.5864 20.1774 29.5864 20.1774C29.5864 20.1774 30.5229 20.6898 30.7173 20.3634C30.9118 20.037 32.1747 20.2325 31.9519 19.7339C31.7292 19.2354 30.2811 18.6445 30.2811 18.6445Z"
                fill="#00A651"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.6883 11.1823C23.6883 11.1823 24.5177 10.804 24.9283 11.1823C25.3389 11.5607 25.6753 11.151 25.6753 10.9228C25.6753 10.6945 26.3273 9.91107 26.3273 10.5467C26.3273 11.1823 26.1243 11.5412 26.6974 11.5412C27.2704 11.5412 29.8509 10.6632 30.4697 10.9228C31.0885 11.1823 31.562 11.1178 31.4047 10.7453C31.2474 10.3729 30.8431 10.1401 30.0647 10.3434C29.2862 10.5467 29.4699 10.7453 28.7971 10.7453C28.1244 10.7453 27.3755 10.5467 27.3755 10.5467C27.3755 10.5467 27.5859 10.2127 28.354 10.4503C29.1221 10.6879 30.1815 10.1561 30.4697 10.1561C30.7578 10.1561 31.5508 10.1401 31.6294 10.3434C31.708 10.5467 32.1869 10.7332 31.8219 10.9228C31.4569 11.1123 30.8551 11.231 31.2692 11.4738C31.6833 11.7166 32.6355 11.6698 32.6814 11.9224C32.7273 12.175 33.1786 12.5521 32.9975 12.5521C32.8163 12.5521 32.489 12.9078 32.1842 12.7995C31.8793 12.6912 31.8435 12.5961 32.1358 12.5084C32.4281 12.4206 32.4252 12.0517 32.1842 12.0517C31.9431 12.0517 32.0607 12.1809 31.5118 12.0517C30.9629 11.9224 30.2364 11.7787 30.2801 12.0517C30.3238 12.3246 30.6812 12.7437 30.0218 12.7995C29.3625 12.8554 29.0538 13.0796 28.9255 12.899C28.7971 12.7185 28.3384 12.4779 28.6991 12.4007C29.0598 12.3236 29.4045 12.663 29.5345 12.6075C29.6644 12.5521 29.9588 12.5213 29.7122 12.2865C29.4656 12.0517 29.0589 11.9134 29.4359 11.7377C29.8129 11.5619 29.5154 11.5583 28.7971 11.9224C28.0789 12.2865 27.6794 12.5959 27.0488 12.5521C26.4183 12.5084 26.1821 12.5674 25.9794 12.5084C25.7767 12.4494 24.7896 13.1605 24.5054 12.98C24.2212 12.7995 23.3035 12.7303 23.4687 12.5084C23.6339 12.2865 23.8557 12.1722 24.1027 12.2865C24.3497 12.4007 24.5952 12.515 24.7617 12.4007C24.9283 12.2865 25.4094 11.8944 25.2884 11.8161C25.1674 11.7377 25.2844 11.4738 24.5993 11.4738C23.9142 11.4738 23.6733 11.7679 23.5107 11.5826C23.3481 11.3973 23.6883 11.1823 23.6883 11.1823Z"
                fill="#FFD100"
              />
            </g>
            <rect width="20.25" height="14" fill="#2B409A" />
            <mask
              id="mask3_800_124137"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="21"
              height="14"
            >
              <rect width="20.25" height="14" fill="white" />
            </mask>
            <g mask="url(#mask3_800_124137)">
              <path
                d="M-2.25488 12.9998L2.20119 14.737L20.351 1.88872L22.7015 -0.69281L17.9364 -1.27343L10.5335 4.26326L4.57493 7.99369L-2.25488 12.9998Z"
                fill="#F7FCFF"
              />
              <path
                d="M-1.64502 14.2169L0.625142 15.225L21.8573 -0.932678H18.6697L-1.64502 14.2169Z"
                fill="#F50100"
              />
              <path
                d="M22.5049 12.9998L18.0488 14.737L-0.101032 1.88872L-2.45151 -0.69281L2.31362 -1.27343L9.71651 4.26326L15.6751 7.99369L22.5049 12.9998Z"
                fill="#F7FCFF"
              />
              <path
                d="M22.353 13.8733L20.0829 14.8815L11.042 7.96351L8.36158 7.19059L-2.67748 -0.683947H0.510086L11.5429 7.00368L14.4735 7.9305L22.353 13.8733Z"
                fill="#F50100"
              />
              <mask
                id="path-40-outside-1_800_124137"
                maskUnits="userSpaceOnUse"
                x="-2"
                y="-2"
                width="24"
                height="18"
                fill="black"
              >
                <rect fill="white" x="-2" y="-2" width="24" height="18" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.2326 0H8.98256V6H0V8H8.98256V14H11.2326V8H20.25V6H11.2326V0Z"
                />
              </mask>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.2326 0H8.98256V6H0V8H8.98256V14H11.2326V8H20.25V6H11.2326V0Z"
                fill="#F50100"
              />
              <path
                d="M8.98256 0V-1.5H7.48256V0H8.98256ZM11.2326 0H12.7326V-1.5H11.2326V0ZM8.98256 6V7.5H10.4826V6H8.98256ZM0 6V4.5H-1.5V6H0ZM0 8H-1.5V9.5H0V8ZM8.98256 8H10.4826V6.5H8.98256V8ZM8.98256 14H7.48256V15.5H8.98256V14ZM11.2326 14V15.5H12.7326V14H11.2326ZM11.2326 8V6.5H9.73256V8H11.2326ZM20.25 8V9.5H21.75V8H20.25ZM20.25 6H21.75V4.5H20.25V6ZM11.2326 6H9.73256V7.5H11.2326V6ZM8.98256 1.5H11.2326V-1.5H8.98256V1.5ZM10.4826 6V0H7.48256V6H10.4826ZM0 7.5H8.98256V4.5H0V7.5ZM1.5 8V6H-1.5V8H1.5ZM8.98256 6.5H0V9.5H8.98256V6.5ZM10.4826 14V8H7.48256V14H10.4826ZM11.2326 12.5H8.98256V15.5H11.2326V12.5ZM9.73256 8V14H12.7326V8H9.73256ZM20.25 6.5H11.2326V9.5H20.25V6.5ZM18.75 6V8H21.75V6H18.75ZM11.2326 7.5H20.25V4.5H11.2326V7.5ZM9.73256 0V6H12.7326V0H9.73256Z"
                fill="#F7FCFF"
                mask="url(#path-40-outside-1_800_124137)"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124137">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Fiji;
